import React from "react";
import { path } from "ramda";
import { Cell, Header } from "./commonElements";
import i18n from "../../../../i18n.js";

export const diabetesRiskDef = iconTypes => ({
    minWidth: 92,
    accessor: "ausdriskScoreValue",
    Cell: row => <Cell row={row} value={path(["value"], row)} />,
    Header: () => <Header label={i18n.t("words.diabetes_risk")} iconType={iconTypes.diabetesRisk} />
});
